import { useMemo } from 'react';

import { Agreement } from '@/shared/api/borrow';

export const useGetAgreement = (allItems: Agreement[], itemIndex: number) => {
    return useMemo(() => {
        const agreement = allItems[itemIndex];

        return {
            address: agreement.address,
            title: agreement.title,
            leverage: agreement.leverage,
            apy: agreement.apy,
            totalDeposited: agreement.totalDeposited,
            totalDepositThreshold: agreement.totalDepositThreshold,
            noWalletInfo: agreement.noWalletInfo,
            errorContract: agreement.errorContract,
        };
    }, [allItems, itemIndex]);
};
